
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
// Add timeout
import 'rxjs/add/operator/retry';
import 'rxjs/add/operator/timeout';
import 'rxjs/add/operator/delay';

import * as Config from '../../app/app.config';
import { Storage } from '@ionic/storage';
import { LoadingController } from 'ionic-angular';
import { AlertProvider } from '../../providers/alert/alert';
/*
  Generated class for the CertificatedProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CertificatedProvider {

  constructor(
    public http: Http,
    private storage: Storage,
    private loadingCtrl: LoadingController,
    private alertProvider: AlertProvider,
    ) {
    console.log('Hello CertificatedProvider Provider');
  }

  //
  public doVerificationCertificated(federalCode: string) {
    let that = this;

    return Observable.create((observer: any) => {
      //let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.post(Config.baseUrl + '/users/certificated/verify/' + federalCode, '')
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  // public doVerificationCertificated(data: any): Observable<any[]> {
  //   let that = this;
  //   console.log('doVerificationCertificated',data);
  //  return Observable.create((observer: any) => {
  //
  //
  //       let loader = this.loadingCtrl.create({
  //         content: 'Verificando...',
  //         //duration: 3000
  //       });
  //       loader.present();
  //
  //       // console.log(Config.baseUrl + '/users/registration/verify');
  //
  //
  //       this.http.post(Config.baseUrl + '/users/certificated/verify', data)
  //         .map((res: Response) => res.json())
  //         .subscribe((response: any) => {
  //
  //           observer.next(response.response);
  //           observer.complete();
  //           console.log('doVerificationCertificated -- data ----->',data);
  //           console.log('doVerificationCertificated -- response ----->',response);
  //
  //         }, (error: any) => {
  //
  //           console.log(error);
  //           loader.dismiss();
  //           that.alertProvider.doAlert('Houve problemas ao verificar suas informações.', 'Atenção');
  //
  //           observer.next(null);
  //           observer.complete();
  //
  //         });
  //     loader.dismiss();
  //
  //   });
  // }
}



// WEBPACK FOOTER //
// ./src/providers/certificated/certificated.ts